module.exports = __webpack_public_path__ + "static/img/4.6f0e945b.png";